import axios from 'axios';
import * as Sentry from "@sentry/vue";

const AUTH_TOKEN = 'Bearer test'

const defaultPayment = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL + '/api/',
    headers: {
        "Content-Type": "application/json",
        Authorization: AUTH_TOKEN,
    }
})

defaultPayment.interceptors.response.use(
  (config) => {
      return config
  },
  (error) => {
      Sentry.captureException(error);
      return Promise.reject(error)
  }
)

export const initPayment = (payload) => {
    return defaultPayment.post('/web-payment/init/card-payment/', payload)
}

export const acceptPayment = (payload) => {
  if (ttq) ttq.track('AddPaymentInfo')
    return defaultPayment.post('/web-payment/accept/card-payment/', payload)
}

export const payPalInitPayemnt = (payload) => {
    return defaultPayment.post('/web-payment/init/pay-pal-payment/', payload)
}

export const payPalAcceptPayment = (payload) => {
  if (ttq) ttq.track('AddPaymentInfo')
    return defaultPayment.post('/web-payment/accept/pay-pal-payment', payload)
}

export const addonFetch = (payload) => {
    return defaultPayment.post('/web-payment/addons/', payload)
}
